import clsx from 'clsx'
import styles from './index.module.sass'

const SpecBlock = ({ item, useButtonStyle = false, isActive = false, onSelected }) => {
  return (
    <div className={useButtonStyle ? styles.blockHasBorder : styles.block}>
      <div
        className={clsx(
          isActive
            ? styles.active
            : ''
        )}
        onClick={() => {
          if (!useButtonStyle) return
          onSelected(item)
        }}
      >
        { item.name }
      </div>
    </div>
  )
}

export default SpecBlock
